import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import type { Direction } from '@mui/material';

export const useDirection = () => {
  const { i18n } = useTranslation();
  const direction: Direction = i18n.dir();

  useEffect(() => {
    document.dir = direction;
  }, [direction]);

  return direction;
};
